const API = '/api';

let _token = localStorage.getItem('token');
let _onUnauth = null;

export function setToken(token) {
  _token = token;
  if (token) localStorage.setItem('token', token);
  else localStorage.removeItem('token');
}

export function getToken() { return _token; }

export function onUnauthorized(fn) { _onUnauth = fn; }

export async function apiFetch(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    ...opts,
    headers: {
      ...opts.headers,
      ..._token ? { Authorization: `Bearer ${_token}` } : {},
    },
  });
  if (res.status === 401) {
    _onUnauth?.();
    return null;
  }
  return res;
}

export async function apiJson(path, opts = {}) {
  const res = await apiFetch(path, opts);
  if (!res) return null;
  return res.json();
}

export async function apiPost(path, body) {
  return apiJson(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function apiPut(path, body) {
  return apiJson(path, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function apiDelete(path) {
  return apiJson(path, { method: 'DELETE' });
}

export async function login(username, password) {
  const form = new URLSearchParams();
  form.append('username', username);
  form.append('password', password);
  const res = await fetch(`${API}/auth/login`, { method: 'POST', body: form });
  if (!res.ok) throw new Error('Invalid credentials');
  const data = await res.json();
  setToken(data.access_token);
  return data;
}
